import { getEncodedQuery, getOnlyNeccessaryFilters } from '@app/logic/filters';
import { ProductFilters } from '@typings';
import { parse, stringify } from 'qs';
import { omit } from 'ramda';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { isEmpty } from '../isEmpty';

export const useSyncFiltersSearchQuery = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return React.useCallback(
    (filters: ProductFilters, sort: string | undefined) => {
      const newSearchToUpdate = getEncodedQuery(getOnlyNeccessaryFilters(filters));
      const currentSearch = parse(search, { ignoreQueryPrefix: true });
      const updatedSearch =
        isEmpty(newSearchToUpdate) ? { ...omit(['filters'], currentSearch), sort } : { ...currentSearch, filters: newSearchToUpdate, sort };

      navigate(
        {
          pathname: window.location.pathname,
          search: stringify(updatedSearch, { encode: false }),
        },
        { replace: true },
      );
    },
    [navigate, search],
  );
};
